import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { IonicModule, ModalController  } from '@ionic/angular';
import { ModalAlertProp, NotificationConfig, NotificationTypeEnum } from 'src/app/models/config-view-models';

@Component({
  selector: 'app-alert-modal',
  templateUrl: './alert-modal.component.html',
  styleUrls: ['./alert-modal.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule],
})
export class AlertModalComponent  implements OnInit {
  @Input() modalProps!: ModalAlertProp; 


  color: string = NotificationConfig[NotificationTypeEnum.Warning].color;
  icon: string =NotificationConfig[NotificationTypeEnum.Warning].icon;
  NotificationConfig = NotificationConfig;
  NotificationEnum = NotificationTypeEnum;
  _countdown = 0;
  private intervalId?: any; // Store the interval ID for clearing it later

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.icon= NotificationConfig[this.modalProps.notificationType].icon;
    this.color= NotificationConfig[this.modalProps.notificationType].color;

    if (!!this.modalProps.counter) {
      this._countdown = this.modalProps.counter;
      this.intervalId = setInterval(() => {
        this._countdown--;
        if (this._countdown <= 0) {
          // auto-close or auto-logout if you wish:
          // e.g. call the onAccept or something else:
          console.log('Countdown ended - dismissing modal...');
          this.dismiss();
          if (this.modalProps.onCounterElapsed) {
            this.modalProps.onCounterElapsed();  // Call the onCounterDismissal callback
          }

        }
      }, 1000);
    }
  }
  accept() {
    if (this.modalProps.onConfirmation) {
      this.modalProps.onConfirmation();  // Call the accept callback
    }
    this.dismiss();
  }
  
  // Dismiss the modal
  dismiss() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = undefined;
    }
    this.modalController.dismiss();
  }
  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
  get countdownResult(){
    // 1) Convert _countdown to hours, minutes, seconds
    const hours = Math.floor(this._countdown / 3600);
    const remainingAfterHours = this._countdown % 3600;
    const minutes = Math.floor(remainingAfterHours / 60);
    const seconds = remainingAfterHours % 60;

    // 2) Zero-pad each field to 2 digits
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');
    const ss = seconds.toString().padStart(2, '0');

    // 3) Return the result
    return `${hh}:${mm}:${ss}`;
  }
  

}
